// Specialized permissions only make sense for particular modules. Filtering
// affects presentation only; saved role values remain intact.
const SPECIAL_ACTION_MENUS = {
  po: [],
  msa: [],
  sourcing: ['jobs'],
  assign: ['jobs'],
  approve: ['submissions', 'onboarding', 'assignments', 'timesheet', 'vendors', 'test cases'],
  move_onboard: ['submissions'],
  change_status: ['jobs', 'candidates', 'submissions', 'onboarding', 'assignments'],
  candidate_self: ['candidates'],
  candidate_all: ['candidates'],
  my_jobs: ['jobs'],
  all_jobs: ['jobs'],
  reject: ['submissions', 'onboarding', 'assignments', 'timesheet', 'vendors', 'test cases'],
  viewProposedRate: ['submissions'],
  po_msa: ['onboarding'],
  // ReApprove — gates who may resend an onboarding finance request to the CFO
  // after a rejection (Approve alone only gates the FIRST send). See the
  // "MSI" role in cmd/wire-delivery-msi-roles.
  reApprove: ['onboarding'],
  // SendApprove gates both the first Send for Approval and any resend.
  sendApprove: ['onboarding'],
};

export function isPermissionApplicable(menuName, permissionKey) {
  const wantedKey = String(permissionKey ?? '').trim().toLowerCase();
  const canonicalKey = Object.keys(SPECIAL_ACTION_MENUS).find(
    (key) => key.toLowerCase() === wantedKey,
  );
  const applicableMenus = canonicalKey ? SPECIAL_ACTION_MENUS[canonicalKey] : undefined;
  if (!applicableMenus) return true;
  return applicableMenus.includes(String(menuName ?? '').trim().toLowerCase());
}
